
export default {
  props: {
    isLarge: {
      type: Boolean,
      default: false,
    },
  },
};
